import { gql } from 'apollo-boost';

export const CATEGORIES_QUERY = gql`
  query categories {
    categories {
      edges {
        node {
          id
          locales {
            code
            name
            description
          }
          sortOrder
          brand {
            id
            name
            slug
            segmentId
          }
        }
      }
    }
  }
`;
